import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyCs5() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`V.`}
            <br />
            {`Trvání smlouvy`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Smlouva je uzavřena na dobu neurčitou, není-li sjednáno výslovně jinak.`}</li>
            <li>{`Smlouvu může kterákoliv ze smluvních stran vypovědět výpovědí, a to i bez uvedení důvodu. Výpovědní lhůta činní 1 měsíc, a začne běžet od prvního dne měsíce následujícího po měsíci, ve kterém k doručení výpovědi došlo a skončí posledním dnem takového měsíce. `}</li>
            <li>{`Výpověď může být uživatelem provedena i e-mailem z aktuální e-mailové adresy uvedené v uživatelském účtu uživatele, či v rámci uživatelského účtu uživatele.`}</li>
            <li>{`Za výpověď ze strany uživatele se považuje rovněž to, pokud uživatel neuhradí do 10 dnů od konce posledního aktuálně uhrazeného předplatitelského období cenu (či její část) za službu na další období. V takovém případě zaniká smlouva uplynutím posledního dne této 10 denní lhůty.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={5} className={sList}>
            <li>{`Uživatel, který je spotřebitelem, má v souladu s ustanovením § 1829 odst. 1 občanského zákoníku právo od smlouvy odstoupit, a to do 14 dnů od jejího uzavření. Odstoupení od smlouvy musí být poskytovateli odesláno ve lhůtě uvedené v předchozí větě. `}</li>
            <li>{`Pro odstoupení od smlouvy může uživatel využit vzorový formulář poskytovaný poskytovatelem, který je přílohou těchto obchodních podmínek. `}</li>
            <li>{`Uživatel odesláním objednávky souhlasí s tím, že poskytovatel může začít s poskytováním služby ihned po doručení objednávky, a to i před uplynutím zákonné lhůty pro odstoupení od smlouvy. Poskytnutím služby (tj. digitálního obsahu) pozbývá uživatel práva na odstoupení od smlouvy v období prvních 14 dnů od jejího uzavření. `}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyCs5;
